/** The counters of a mode grouped by zone (plus the motor counters past the last zone), as the pickers list them. */
import { getModeConfig } from '@/config/modeConfig';

export interface ZoneGroup {
  label: string;
  counters: number[];
}

export function buildZoneGroups(operationMode: string | undefined): ZoneGroup[] {
  const { zones, numCounters } = getModeConfig(operationMode);
  const groups: ZoneGroup[] = zones.map((z, i) => ({
    label: `Zone ${i + 1}`,
    counters: Array.from({ length: z[1] - z[0] }, (_, k) => z[0] + k + 1),
  }));
  const lastZoneEnd = zones[zones.length - 1][1];
  if (lastZoneEnd < numCounters) {
    groups.push({
      label: 'Motor',
      counters: Array.from({ length: numCounters - lastZoneEnd }, (_, k) => lastZoneEnd + k + 1),
    });
  }
  return groups;
}
